/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	$('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
			$(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			$(this).wrap("<div class='responsive-embed'/>");
		}
	});

	// Prevent Dropdown buttons in Main Nav from doing anything when clicked
	$('.menu-item a[href="#"]').on('click', function(event) {
		event.preventDefault();
	  });
	
	const $menu = $('#off-canvas'); 
	const $overlay = $('#off-canvas-overlay');
  
	function toggleOverlay() {
	  const isHidden = $menu.attr('aria-hidden') === 'true';
	  $overlay.attr('aria-expanded', !isHidden);
	}
  
	// Monitor changes to the `aria-hidden` attribute
	$menu.on('attributeChange', function () {
	  toggleOverlay();
	});
  
	// Initial setup: set overlay state based on current `aria-hidden` value
	toggleOverlay();

	// Specialty Materials horizontal bar graph
$('.sg-bar-graph .material-buttons button').on('click', function () {
    // Remove active class from all buttons and add to the clicked one
    $('.sg-bar-graph .material-buttons button').removeClass('active');
    $(this).addClass('active');

    // Get the widths from the data attribute of the clicked button
    const widths = JSON.parse($(this).attr('data-bars'));

    // Update bar widths and switch active class
    $('.sg-bar-graph .bar-graph .bar').each(function (index) {
        $(this).css('width', widths[index] + '%');
    });

    // Highlight the bar with the largest width
    $('.sg-bar-graph .bar-graph .bar').removeClass('active')
        .eq(widths.indexOf(Math.max(...widths))).addClass('active');
});

$(".sg-cost-graph .material-buttons button").on("click", function () {
	// Remove active class from all buttons
	$(".sg-cost-graph .material-buttons button").removeClass("active");
	// Add active class to the clicked button
	$(this).addClass("active");

	// Determine the index of the clicked button
	const index = $(this).index() + 1; // +1 to match `.bar-*` class numbering

	// Remove active class from all .bar-* elements inside the SVG
	$(".sg-cost-graph .material-cost-graph [class^='bar-']").removeClass("active");

	// Add active class to the corresponding .bar-* element in the SVG
	$(`.sg-cost-graph .material-cost-graph .bar-${index}`).addClass("active");
});

	// Element: "Read More" Toggle Buttons
	var instance = ['1', '2', '3', '4', '5', '6', '7', '8', '9' ];
	$.each( instance, function( i, val ) {
		$('.toggle-' + val).click(function(e){
			e.preventDefault();
			$('.showHide-' + val).slideToggle();
			$(this).text( $(this).text() == 'read more' ? "read less" : "read more");
			$(this).toggleClass('show-active');
		});
	});

	// Element: Mobile "Read More" Toggle Buttons
	if ($(window).width() < 640) {
		var mobileInstance = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12' ];
		$.each( mobileInstance, function( i, val ) {
			$('.mobile-toggle-' + val).click(function(e){
				e.preventDefault();
				$('.mobile-showHide-' + val).slideToggle();
				$(this).toggleClass('mobile-show-active');
			});
		});
	}
	
	if (window.location.pathname === '/sitemap' || window.location.pathname === '/sitemap/') {
		$('#primary').css({
		  'max-width': '1200px',
		  'margin': '48px auto',
		  'padding': '0 15px'
		});

		$('#content').css({
		  'list-style-type': 'none'
		});

		$('#content li a').css({
		  'color': '#000',
		});

		$('#content li').hover(
			function () {
			  $(this).css('text-decoration', 'underline');
			},
			function () {
			  $(this).css('text-decoration', 'none');
			}
		  );
	  
		$('#content').prepend('<h1>Sitemap</h1>');
		
		$('#content h1').css({
			'color': '#112A4C',
			'margin-bottom': '32px'
		});
	}

	  $('#state-selector').on('change', function () {
		var selectedState = $(this).val();
	
		// Hide all state links
		$('.state-links').removeClass('active');
	
		// Show the links for the selected state
		if (selectedState) {
		  $('#' + selectedState).addClass('active');
		}
	  });

	  $('#TOC a').on('click', function (e) {
        e.preventDefault();

        // Get the target element's offset
        var target = $($(this).attr('href'));
        var offset = target.offset().top;

        // Adjust for custom offset (e.g., 50px for fixed header)
        var customOffset = 80;

        // Scroll to the target with the adjusted offset
        $('html, body').animate({
          scrollTop: offset - customOffset
        }, 500);
      });

	$(window).on('scroll', function () {
		$('#top-of-stick [id]').each(function () {
			var element = $(this);
			var anchor = $("a[href='#" + element.attr('id') + "']");
			var elementPosition = element.offset().top;
			var scrollPosition = $(window).scrollTop();
	
			// Check if the element is 100px away from the top of the viewport
			if (elementPosition <= scrollPosition + 100 && 
				elementPosition + element.outerHeight() > scrollPosition + 100) {
				
				// Remove the 'active-anchor' class from all anchors
				$("a").removeClass('toc-active-anchor');
				
				// Add 'active-anchor' class to the current anchor
				anchor.addClass('toc-active-anchor');
			}
		});
	});
	
	$('.home-our-services a.kb-section-link-overlay').on('mouseover', function () {
        $(this).siblings('.kt-inside-inner-col').find('.wp-block-kadence-advancedheading').css('text-decoration', 'underline');
    });

    $('.home-our-services a.kb-section-link-overlay').on('mouseout', function () {
        $(this).siblings('.kt-inside-inner-col').find('.wp-block-kadence-advancedheading').css('text-decoration', 'none');
    });

		 // Replace with your actual Form ID and Field ID
  var formId = 2;   
  var fieldId = 22;  
  var $hiddenField = $('#input_' + formId + '_' + fieldId);
  if ($hiddenField.length) {
    $hiddenField.val(window.location.href);
  }

   if ($('#gf_2').length) {
    // Match both '/get-a-free-quote' and '/get-a-free-quote/'
    $("a[href='/get-a-free-quote'], a[href='/get-a-free-quote/']").each(function() {
      $(this)
        .attr('href', '#gf_2') // update the href
        .on('click', function(e) {
          e.preventDefault();
          $('html, body').animate({
            scrollTop: $('#gf_2').offset().top - 100 // adjust offset as needed
          }, 300);
        });
    });
  }

		$('.google-map iframe').attr('aria-label', 'Google maps to Brothers Gutters Near You');
	
		function updateMenuClass() {
			var moreNav = $("#more-nav");
			if (moreNav.length) {
				if ($(window).width() <= 1024) { // Adjust breakpoint as needed
					moreNav.removeClass("is-dropdown-submenu first-sub").addClass("is-accordion-submenu");
					moreNav.css("display", "none");
				} 
			}
		}
	
		updateMenuClass(); // Run on page load
		$(window).resize(updateMenuClass); // Run on window resize

}); 

// // Scheduling Form Functions
// jQuery(document).ready(function ($) {
// 	$("#gform_confirmation_message_5 br").remove();
  
// 	if ($(".zip-not-found").length) {
// 	  $("#scheduler-icons").css("display", "none");
// 	}
  
// 	const $monthSelect = $(".monthSelect");
// 	const $yearSelect = $(".yearSelect");
// 	const $calendarBody = $(".calendarBody");
  
// 	const months = [
// 	  "January",
// 	  "February",
// 	  "March",
// 	  "April",
// 	  "May",
// 	  "June",
// 	  "July",
// 	  "August",
// 	  "September",
// 	  "October",
// 	  "November",
// 	  "December",
// 	];
  
// 	const today = new Date();
// 	let currentMonth = today.getMonth();
// 	let currentYear = today.getFullYear();
// 	let selectedDate = new Date(today);
  
// 	function populateMonthYear() {
// 	  $monthSelect.empty();
// 	  $.each(months, function (i, m) {
// 		$monthSelect.append(
// 		  $("<option>", { value: i, text: m, selected: i === currentMonth })
// 		);
// 	  });
  
// 	  const startYear = today.getFullYear();
// 	  const endYear = today.getFullYear() + 1;
// 	  $yearSelect.empty();
// 	  for (let y = startYear; y <= endYear; y++) {
// 		$yearSelect.append(
// 		  $("<option>", { value: y, text: y, selected: y === currentYear })
// 		);
// 	  }
// 	}
  
// 	// Update date-info element with current day and date
// 	function updateDateInfo() {
// 	  var today = new Date();
// 	  var dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  
// 	  $(".date-info .day").text(dayNames[today.getDay()]);
// 	  $(".date-info .date").text(today.getDate().toString().padStart(2, "0"));
// 	}
  
// 	updateDateInfo();
  
// 	function renderCalendar(month, year, noSlotSet) {
// 	  const firstDay = new Date(year, month, 1).getDay();
// 	  const daysInMonth = new Date(year, month + 1, 0).getDate();
// 	  const prevMonthDays = new Date(year, month, 0).getDate();
  
// 	  $calendarBody.empty();
// 	  let date = 1;
  
// 	  for (let i = 0; i < 6; i++) {
// 		const $row = $("<tr>");
// 		for (let j = 0; j < 7; j++) {
// 		  const $cell = $("<td>");
  
// 		  if (i === 0 && j < firstDay) {
// 			$cell.text(prevMonthDays - firstDay + j + 1).addClass("inactive");
// 		  } else if (date > daysInMonth) {
// 			$cell.text(date - daysInMonth).addClass("inactive");
// 			date++;
// 		  } else {
// 			const cellDate = new Date(year, month, date);
// 			$cell.text(date);
  
// 			// 🔒 Disable past dates
// 			if (
// 			  cellDate <
// 			  new Date(today.getFullYear(), today.getMonth(), today.getDate())
// 			) {
// 			  $cell.addClass("inactive");
// 			} else {
// 			  // ✅ Only allow future dates or today to be selected
// 			  $cell.on("click", function () {
// 				$(".time-slot").removeClass("selected");
// 				const clickedDate = parseInt($(this).text());
// 				selectedDate = new Date(year, month, clickedDate);
  
// 				// Remove 'active' class from all cells
// 				$calendarBody.find("td").removeClass("active");
  
// 				// Add 'active' class to clicked cell
// 				$(this).addClass("active");
  
// 				// Update the todays-date span with selected date
// 				const selectedDateFormatted =
// 				  months[month] + " " + clickedDate + ", " + year;
// 				$(".todays-date").text(selectedDateFormatted);
  
// 				// Update date-info element
// 				const dayNames = [
// 				  "Sun",
// 				  "Mon",
// 				  "Tue",
// 				  "Wed",
// 				  "Thu",
// 				  "Fri",
// 				  "Sat",
// 				];
// 				$(".date-info .day").text(dayNames[selectedDate.getDay()]);
// 				$(".date-info .date").text(
// 				  clickedDate.toString().padStart(2, "0")
// 				);
  
// 				// Fetch new time slots for selected date
// 				fetchTimeSlotsForDate(selectedDate);
// 			  });
// 			}
  
// 			// Add today class
// 			if (
// 			  cellDate.getDate() === today.getDate() &&
// 			  cellDate.getMonth() === today.getMonth() &&
// 			  cellDate.getFullYear() === today.getFullYear()
// 			) {
// 			  $cell.addClass("today");
// 			}
  
// 			// Add active class if this cell is currently selected
// 			if (
// 			  selectedDate &&
// 			  selectedDate.getDate() === date &&
// 			  selectedDate.getMonth() === month &&
// 			  selectedDate.getFullYear() === year
// 			) {
// 			  $cell.addClass("active");
// 			}
  
// 			// Mark no-time-slots if provided
// 			if (!$(
// 			  $cell
// 			).hasClass("inactive") && noSlotSet && noSlotSet.size > 0) {
// 			  const cellDateStr =
// 				cellDate.getFullYear() +
// 				"-" +
// 				String(cellDate.getMonth() + 1).padStart(2, "0") +
// 				"-" +
// 				String(cellDate.getDate()).padStart(2, "0");
// 			  if (noSlotSet.has(cellDateStr)) {
// 				$cell.addClass("no-time-slots");
// 			  }
// 			}
  
// 			date++;
// 		  }
// 		  $row.append($cell);
// 		}
// 		$calendarBody.append($row);
// 	  }
// 	}
  
// 	let calendarFirstLoad = true;
  
// 	// Helper function to update min-height based on overlay visibility
// 	function updateMinHeightForOverlay() {
// 	  const $overlay = $("#calendar-loading-overlay");
// 	  const $col = $("#scheduler-form .kt-inside-inner-col");
	  
// 	  if ($overlay.length > 0 && $overlay.css("display") !== "none" && parseFloat($overlay.css("opacity")) > 0) {
// 		$col.css("min-height", "450px");
// 	  } else {
// 		$col.css("min-height", "");
// 	  }
// 	}
  
//   function showMonth(month, year, afterRenderCb) {
// 	const firstDay = new Date(year, month, 1);
// 	const lastDay = new Date(year, month + 1, 0);
  
// 	const formatDate = (d) =>
// 	  d.getFullYear() +
// 	  "-" +
// 	  String(d.getMonth() + 1).padStart(2, "0") +
// 	  "-" +
// 	  String(d.getDate()).padStart(2, "0");
  
// 	const $wrapper = jQuery("#gform_page_5_2");
  
// 	// First load overlay
// 	if (calendarFirstLoad) {
// 	  if ($wrapper.find("#calendar-loading-overlay").length === 0) {
		
// 		$wrapper.css("position", "relative");
  
// 		$wrapper.append(`
// 		  <div id="calendar-loading-overlay" class="calendar-loading-overlay">
// 			<div class="truck-wrapper">
// 			  <img src="/wp-content/themes/BrothersGutters/assets/images/scheduler_truck.png" alt="Loading" class="truck-image" />
// 			</div>
// 			<div class="progress-bar">
// 			  <div class="progress-fill"></div>
// 			</div>
// 			  <h3 class="loading-text">Locating Your Address</h3>
// 		  </div>
// 		`);
// 	  }
  
// 	  const $overlay = $wrapper.find("#calendar-loading-overlay");
// 	  const $progress = $overlay.find(".progress-fill");
// 	  const $truck = $overlay.find(".truck-image");
  
// 	  $overlay.css({ display: 'flex', opacity: 0 }).animate({ opacity: 1 }, 200);
	  
// 	  // Update min-height when overlay is shown
// 	  updateMinHeightForOverlay();
  
// 	  // Animate progress bar + truck position
// 	  const isDesktop = $(window).width() >= 1024; // Only animate truck on desktop
// 	  let progress = 0;
// 	  const interval = setInterval(() => {
// 		if (progress < 90) {
// 		  progress += Math.random() * 10;
// 		  if (progress > 90) progress = 90;
// 		  $progress.css("width", progress + "%");
// 		  if (isDesktop) {
// 			$truck.css("left", `calc(${progress}% - 40px)`); // move truck along bar
// 		  }
// 		}
// 	  }, 400);
  
// 	  $.ajax({
// 		url: "/wp-admin/admin-ajax.php",
// 		type: "POST",
// 		data: {
// 		  action: "get_time_slots_for_month",
// 		  date_from: formatDate(firstDay),
// 		  date_to: formatDate(lastDay),
// 		},
// 		success: function (response) {
// 		  clearInterval(interval);
// 		  $progress.css("width", "100%");
// 		  if (isDesktop) {
// 			$truck.css("left", "calc(100% - 40px)");
// 		  }
  
// 		  let noSlotSet = null;
// 		  if (
// 			response &&
// 			response.success &&
// 			response.data &&
// 			Array.isArray(response.data.dates_no_slots)
// 		  ) {
// 			noSlotSet = new Set(response.data.dates_no_slots);
// 		  }
  
// 		  renderCalendar(month, year, noSlotSet);
// 		  if (typeof afterRenderCb === "function") afterRenderCb(noSlotSet);
  
// 		  setTimeout(() => {
// 			$overlay.fadeOut(400, () => {
// 			  $overlay.remove();
// 			  updateMinHeightForOverlay();
// 			});
// 			calendarFirstLoad = false;
// 		  }, 500);
// 		},
// 		error: function () {
// 		  clearInterval(interval);
// 		  $progress.css("width", "100%");
// 		  if (isDesktop) {
// 			$truck.css("left", "calc(100% - 40px)");
// 		  }
  
// 		  renderCalendar(month, year, null);
// 		  if (typeof afterRenderCb === "function") afterRenderCb(null);
  
// 		  setTimeout(() => {
// 			$overlay.fadeOut(400, () => {
// 			  $overlay.remove();
// 			  updateMinHeightForOverlay();
// 			});
// 			calendarFirstLoad = false;
// 		  }, 500);
// 		},
// 	  });
  
// 	  return; // prevent showing inline spinner on first load
// 	}
  
// 	// Regular inline loading for subsequent month changes
// 	$calendarBody.empty().append(
// 	  $("<tr>").append(
// 		$("<td>")
// 		  .attr("colspan", 7)
// 		  .append('<div class="loading-spinner"></div>')
// 	  )
// 	);
  
// 	$.ajax({
// 	  url: "/wp-admin/admin-ajax.php",
// 	  type: "POST",
// 	  data: {
// 		action: "get_time_slots_for_month",
// 		date_from: formatDate(firstDay),
// 		date_to: formatDate(lastDay),
// 	  },
// 	  success: function (response) {
// 		let noSlotSet = null;
// 		if (
// 		  response &&
// 		  response.success &&
// 		  response.data &&
// 		  Array.isArray(response.data.dates_no_slots)
// 		) {
// 		  noSlotSet = new Set(response.data.dates_no_slots);
// 		}
// 		renderCalendar(month, year, noSlotSet);
// 		if (typeof afterRenderCb === "function") afterRenderCb(noSlotSet);
// 	  },
// 	  error: function () {
// 		renderCalendar(month, year, null);
// 		if (typeof afterRenderCb === "function") afterRenderCb(null);
// 	  },
// 	});
  
// 	// Watch for overlay changes using MutationObserver as fallback
// 	const observer = new MutationObserver(function() {
// 	  updateMinHeightForOverlay();
// 	});
  
// 	// Observe the wrapper for changes
// 	if ($wrapper.length > 0) {
// 	  observer.observe($wrapper[0], {
// 		childList: true,
// 		subtree: true,
// 		attributes: true,
// 		attributeFilter: ['style', 'class']
// 	  });
// 	}
  
// 	// Initial check
// 	updateMinHeightForOverlay();
//   }
  
// 	function nextMonth(e) {
// 	  e.preventDefault();
// 	  const nextMonthValue = (currentMonth + 1) % 12;
// 	  const nextYearValue = nextMonthValue === 0 ? currentYear + 1 : currentYear;
  
// 	  // Prevent going beyond next year
// 	  if (nextYearValue > today.getFullYear() + 1) return;
  
// 	  currentMonth = nextMonthValue;
// 	  currentYear = nextYearValue;
// 	  showMonth(currentMonth, currentYear);
// 	  updateSelectors();
// 	}
  
// 	function prevMonth(e) {
// 	  e.preventDefault();
// 	  currentMonth = (currentMonth - 1 + 12) % 12;
// 	  if (currentMonth === 11) currentYear--;
// 	  showMonth(currentMonth, currentYear);
// 	  updateSelectors();
// 	}
  
// 	function updateSelectors() {
// 	  $monthSelect.val(currentMonth);
// 	  $yearSelect.val(currentYear);
// 	}
  
// 	$(".prev").on("click", prevMonth);
// 	$(".next").on("click", nextMonth);
  
// 	$monthSelect.on("change", function () {
// 	  currentMonth = parseInt($(this).val());
// 	  showMonth(currentMonth, currentYear);
// 	});
  
// 	$yearSelect.on("change", function () {
// 	  currentYear = parseInt($(this).val());
// 	  showMonth(currentMonth, currentYear);
// 	});
  
// 	populateMonthYear();
// 	showMonth(currentMonth, currentYear);
  
// 	function updateGravityFormField() {
// 	  const selectedTime = $(".time-slot.selected").text();
// 	  const dateToUse = selectedDate || today;
  
// 	  // Update separate fields
// 	  const dayNames = [
// 		"Sunday",
// 		"Monday",
// 		"Tuesday",
// 		"Wednesday",
// 		"Thursday",
// 		"Friday",
// 		"Saturday",
// 	  ];
// 	  const dayName = dayNames[dateToUse.getDay()];
// 	  const ordinal = getOrdinal(dateToUse.getDate());
// 	  const dateText = months[dateToUse.getMonth()] + " " + ordinal;
  
// 	  $("#input_5_27").val(dayName); // Appointment Day
// 	  $("#input_5_28").val(dateText); // Appointment Date
// 	  $("#input_5_26").val(selectedTime || ""); // Time slot only
// 	}
  
// 	function getOrdinal(day) {
// 	  if (day > 3 && day < 21) return day + "th";
// 	  switch (day % 10) {
// 		case 1:
// 		  return day + "st";
// 		case 2:
// 		  return day + "nd";
// 		case 3:
// 		  return day + "rd";
// 		default:
// 		  return day + "th";
// 	  }
// 	}
  
// 	// Time slot selection
// 	$(".time-slot").on("click", function () {
// 	  $(".time-slot").removeClass("selected");
// 	  $(this).addClass("selected");
// 	  updateGravityFormField();
// 	});
  
// 	// Function to fetch time slots for selected date
// 	function fetchTimeSlotsForDate(date) {
// 	  const formattedDate =
// 		date.getFullYear() +
// 		"-" +
// 		String(date.getMonth() + 1).padStart(2, "0") +
// 		"-" +
// 		String(date.getDate()).padStart(2, "0");
  
// 	  // Show loading spinner
// 	  $(".time-slots").html('<div class="loading-spinner"></div>');
  
// 	  $.ajax({
// 		url: "/wp-admin/admin-ajax.php",
// 		type: "POST",
// 		data: {
// 		  action: "get_time_slots_for_date",
// 		  selected_date: formattedDate,
// 		},
// 		success: function (response) {
// 		  if (response.success) {
// 			$(".time-slots").html($(response.data).html());
// 			// Re-bind click events for new time slots
// 			$(".time-slot").on("click", function () {
// 			  $(".time-slot").removeClass("selected");
// 			  $(this).addClass("selected");
// 			  updateGravityFormField();
// 			});
// 		  }
// 		},
// 		error: function () {
// 		  $(".time-slots").html(
// 			'<div class="error-message">Error loading time slots</div>'
// 		  );
// 		},
// 	  });
// 	}
  
// 	// Day navigation buttons
// 	$(".day-prev").on("click", function (e) {
// 	  e.preventDefault();
// 	  moveToAvailableDay(-1);
// 	});
  
// 	$(".day-next").on("click", function (e) {
// 	  e.preventDefault();
// 	  moveToAvailableDay(1);
// 	});
  
// 	function cellHasNoAvailability(dateObj) {
// 	  const day = dateObj.getDate();
// 	  const $cell = $calendarBody
// 		.find("td")
// 		.filter(function () {
// 		  const $c = $(this);
// 		  return !$c.hasClass("inactive") && parseInt($c.text(), 10) === day;
// 		})
// 		.first();
// 	  if ($cell.length === 0) return true; // not found, treat as unavailable
// 	  return $cell.hasClass("no-time-slots");
// 	}
  
// 	function moveToAvailableDay(step) {
// 	  $(".time-slot").removeClass("selected");
// 	  if (!selectedDate) selectedDate = new Date();
// 	  let candidate = new Date(selectedDate);
// 	  candidate.setDate(candidate.getDate() + step);
  
// 	  const startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());
// 	  let attempts = 0;
  
// 	  function advanceUntilAvailable() {
// 		attempts++;
// 		if (attempts > 62) return; // safety guard ~2 months
  
// 		// Prevent navigating into the past
// 		if (step < 0 && candidate < startOfToday) return;
  
// 		const candMonth = candidate.getMonth();
// 		const candYear = candidate.getFullYear();
  
// 		// If month view doesn't match candidate, render that month first then continue
// 		if (candMonth !== currentMonth || candYear !== currentYear) {
// 		  currentMonth = candMonth;
// 		  currentYear = candYear;
// 		  showMonth(currentMonth, currentYear, function () {
// 			// After month renders (with availability), check cell and continue
// 			if (cellHasNoAvailability(candidate)) {
// 			  candidate.setDate(candidate.getDate() + step);
// 			  advanceUntilAvailable();
// 			} else {
// 			  selectedDate = new Date(candidate);
// 			  updateSelectors();
// 			  updateDateDisplay();
// 			  fetchTimeSlotsForDate(selectedDate);
// 			}
// 		  });
// 		  return;
// 		}
  
// 		// Month is already rendered for candidate; check availability from DOM
// 		if (cellHasNoAvailability(candidate)) {
// 		  candidate.setDate(candidate.getDate() + step);
// 		  advanceUntilAvailable();
// 		  return;
// 		}
  
// 		// Found available day in current month
// 		selectedDate = new Date(candidate);
// 		updateDateDisplay();
// 		fetchTimeSlotsForDate(selectedDate);
// 	  }
  
// 	  advanceUntilAvailable();
// 	}
  
// 	function updateDateDisplay() {
// 	  const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
// 	  const selectedDateFormatted =
// 		months[selectedDate.getMonth()] +
// 		" " +
// 		selectedDate.getDate() +
// 		", " +
// 		selectedDate.getFullYear();
// 	  $(".todays-date").text(selectedDateFormatted);
// 	  $(".date-info .day").text(dayNames[selectedDate.getDay()]);
// 	  $(".date-info .date").text(
// 		selectedDate.getDate().toString().padStart(2, "0")
// 	  );
  
// 	  // Update calendar if month changed
// 	  if (
// 		selectedDate.getMonth() !== currentMonth ||
// 		selectedDate.getFullYear() !== currentYear
// 	  ) {
// 		currentMonth = selectedDate.getMonth();
// 		currentYear = selectedDate.getFullYear();
// 		showMonth(currentMonth, currentYear);
// 		updateSelectors();
// 	  } else {
// 		// Just update active cell
// 		$calendarBody.find("td").removeClass("active");
// 		$calendarBody
// 		  .find("td")
// 		  .filter(function () {
// 			return (
// 			  $(this).text() == selectedDate.getDate() &&
// 			  !$(this).hasClass("inactive")
// 			);
// 		  })
// 		  .addClass("active");
// 	  }
// 	}
  
// 	function getTodaysDateFormatted() {
// 	  var today = new Date();
  
// 	  // Array of month names
// 	  var monthNames = [
// 		"January",
// 		"February",
// 		"March",
// 		"April",
// 		"May",
// 		"June",
// 		"July",
// 		"August",
// 		"September",
// 		"October",
// 		"November",
// 		"December",
// 	  ];
  
// 	  var month = monthNames[today.getMonth()]; // get month name
// 	  var day = today.getDate(); // day of month
// 	  var year = today.getFullYear(); // year
  
// 	  return month + " " + day + ", " + year;
// 	}
  
// 	var formattedDate = getTodaysDateFormatted();
// 	$(".todays-date").text(formattedDate);
  
// 	function matchWidth() {
// 	  $(".date-info").each(function (index) {
// 		var dateInfoWidth = $(this).outerWidth();
// 		$(".time-slots").eq(index).width(dateInfoWidth);
// 	  });
// 	}
  
// 	matchWidth(); // initial call
// 	setTimeout(matchWidth, 100); // call after 100ms to ensure proper rendering
  
// 	// Optional: update on window resize
// 	$(window).resize(function () {
// 	  matchWidth();
// 	});
  
// 	// Zip code validation - only allow 5 digits
// 	$("#input_5_9").on("input", function () {
// 	  let value = $(this).val().replace(/\D/g, ""); // Remove non-digits
// 	  if (value.length > 5) {
// 		value = value.substring(0, 5); // Limit to 5 digits
// 	  }
// 	  $(this).val(value);
// 	});
  
// 	// Check zip code on blur
// 	$("#input_5_9").on("blur", function () {
// 	  const zipCode = $(this).val().trim();
// 	  const $errorMsg = $("#zip-error-message");
  
// 	  // Remove existing error message
// 	  $errorMsg.remove();
  
// 	  if (zipCode && zipCode.length === 5) {
// 		$.ajax({
// 		  url: "/wp-admin/admin-ajax.php",
// 		  type: "POST",
// 		  data: {
// 			action: "check_zip_code",
// 			zip_code: zipCode,
// 		  },
// 		  success: function (response) {
// 			if (response.success) {
// 			  $("#input_5_16").val(response.data.not_found ? 1 : 0);
// 			}
// 		  },
// 		});
// 	  } else if (
// 		zipCode &&
// 		zipCode.length !== 5 &&
// 		$("#validation_message_5_9").length === 0
// 	  ) {
// 		// Show error message for invalid zip code only if Gravity Forms validation isn't showing
// 		$(this).after(
// 		  '<div id="zip-error-message">Please enter a valid 5 digit zip code</div>'
// 		);
// 	  }
// 	});
  
// 	// Icon classes for form completion
// 	if ($(".gform_confirmation_message_5").length) {
// 	  $(".calendar")
// 		.removeClass("non-active-icon active-icon")
// 		.addClass("filled-icon");
  
// 	  $(".your-info").removeClass("active-icon").addClass("filled-icon");
  
// 	  $(".confirm").removeClass("non-active-icon").addClass("active-icon");
// 	}
//   });
  
//   // Icon classes for form steps
//   jQuery(document).on("gform_post_render", function (event, formId, currentPage) {
// 	if (formId === 5) {
// 	  if (currentPage === 2 || currentPage === 4) {
// 		jQuery(".calendar").removeClass("non-active-icon");
// 		jQuery(".calendar").addClass("active-icon");
// 		jQuery(".your-info").removeClass("active-icon");
// 		jQuery(".your-info").addClass("filled-icon");
// 	  }
// 	}
//   });
  
//   jQuery(document).on('gform_page_loaded', function(event, form_id, current_page){
// 	if(form_id === 5 && current_page === 2) { // change 2 to your form ID
// 	  const $formWrapper = jQuery('#gform_wrapper_' + form_id);
  
// 	  // If overlay doesn't exist yet, add it dynamically
// 	  if ($formWrapper.find('.gf-loading-overlay').length === 0) {
// 		$formWrapper.append(`
// 		  <div class="gf-loading-overlay">
// 			<div class="spinner"></div>
// 			<div>Loading data, please wait...</div>
// 		  </div>
// 		`);
// 	  }
  
// 	  const $overlay = $formWrapper.find('.gf-loading-overlay');
// 	  $overlay.fadeIn(200);
  
// 	  // Example API request
// 	  jQuery.ajax({
// 		url: 'https://yourapi.com/endpoint',
// 		method: 'GET',
// 		dataType: 'json',
// 		headers: { 'Authorization': 'Bearer YOUR_API_KEY' },
// 		success: function(response) {
// 		  // Populate form fields with data
// 		  jQuery('#input_2_5').val(response.name); // example field
// 		  jQuery('#input_2_6').val(response.email); // example field
  
// 		  // Hide overlay
// 		  $overlay.fadeOut(300);
// 		},
// 		error: function(err) {
// 		  console.error('API error:', err);
// 		  alert('There was a problem loading the data.');
// 		  $overlay.fadeOut(300);
// 		}
// 	  });
// 	}
//   });

